import { render, staticRenderFns } from "./ParticipantVideo.vue?vue&type=template&id=04488948&"
import script from "./ParticipantVideo.vue?vue&type=script&lang=ts&"
export * from "./ParticipantVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports